import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

import { baseCss } from './css.js';
const nlDialogCss = baseCss;

const NlDialogStyle0 = nlDialogCss;

const NlDialog = /*@__PURE__*/ proxyCustomElement(class NlDialog extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    componentDidLoad() {
        var _a;
        (_a = this.dialogElement) === null || _a === void 0 ? void 0 : _a.showModal();
    }
    disconnectedCallback() {
        var _a;
        (_a = this.dialogElement) === null || _a === void 0 ? void 0 : _a.close();
    }
    render() {
        return (h("dialog", { key: '2f2dfe3ccb1f617f4a8220cf19e832de98dccce5', ref: el => (this.dialogElement = el), class: 'm-auto nl-banner-dialog', style: { border: '0', backgroundColor: 'transparent' } }, h("slot", { key: 'fcf90b01dd2cbbaae8eb97cca3ec67e75cd61d63' })));
    }
    static get style() { return NlDialogStyle0; }
}, [1, "nl-dialog"]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-dialog"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-dialog":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlDialog);
            }
            break;
    } });
}
defineCustomElement();

export { NlDialog as N, defineCustomElement as d };

//# sourceMappingURL=nl-dialog2.js.map